<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="3">
          <v-list>
            <v-subheader>Initial Data</v-subheader>
            <v-list-item-group>
              <template v-for="(data, index) in initialData">
                <v-list-item
                  :class="{ activeList: dataId == data.id }"
                  @click="setData(data)"
                  :key="index"
                >
                  <v-list-item-content>
                    <v-list-item-title v-text="data.name"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <!-- <v-divider v-if="index < initialData.length - 1"></v-divider> -->
              </template>
            </v-list-item-group>
          </v-list>
        </v-col>
        <v-col lg="9">
          <v-card class="card--shadow">
            <v-card-text>
              <v-row>
                <v-col class="mt-3" md="5">
                  <types-form :typeInfo="typeInfo" />
                </v-col>
                <v-col md="7">
                  <v-card class="elevation-0">
                    <types-list :typeInfo="typeInfo" :basicData="basicData" />
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import TypesForm from "@/components/referral-types/TypesForm";
import TypesList from "@/components/referral-types/TypesList";
import { mapState } from "vuex";
export default {
  data: () => ({
    typeInfo: { id: 1, type: "referral_types", name: "Referral Type" },
    dataId: 1,
    initialData: [
      { id: 1, type: "referral_types", name: "Referral Type" },
      { id: 2, type: "referral_froms", name: "Referral From" },
      { id: 3, type: "hivs", name: "HIV" },
      { id: 4, type: "genexperts", name: "Gene Xperts" },
      { id: 5, type: "case_found_ats", name: "Case Found At" },
      { id: 6, type: "conclusion_treatments", name: "Conclusion Treatment" },
      { id: 7, type: "cxrs", name: "CXR" },
      { id: 8, type: "dsts", name: "DST" },
      { id: 9, type: "cultures", name: "Culture" },
      { id: 10, type: "sputums", name: "Sputum" },
    ],
  }),
  components: {
    TypesForm,
    TypesList,
  },
  computed: {
    ...mapState("InitialData", ["basicData"]),
  },
  methods: {
    setData(data) {
      this.dataId = data.id;
      this.typeInfo = data;
      this.$store.dispatch("InitialData/get", data.type);
    },
  },
  mounted() {
    this.$store.dispatch("InitialData/get", this.typeInfo.type);
  },
  created() {},
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
.activeList {
  background-color: var(--primary-color) !important;
  color: #fff !important;
}
</style>
